import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LessonsPage from './pages/LessonsPage';
import PrivateLessonsPage from './pages/PrivateLessonsPage';
import GroupLessonsPage from './pages/GroupLessonsPage';
import StudioPage from './pages/StudioPage';
import RecordingPage from './pages/RecordingPage';
import VisualPage from './pages/VisualPage';
import LiveSoundPage from './pages/LiveSoundPage';
import GearRentalPage from './pages/GearRentalPage';
import AudioEngineerPage from './pages/AudioEngineerPage';
import ServicesPage from './pages/ServicesPage';
import BookOnlinePage from './pages/BookOnlinePage';
import BookServicePage from './pages/BookServicePage';
import ServicesOverview from './pages/ServicesOverview'
import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Navbar />
      <div className='app-container'>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/services' element={<ServicesOverview />} />
          <Route path="/book-online" element={<BookOnlinePage />} />
          <Route path="/book-service" element={<BookServicePage />} />

          {/* Lessons & Education */}
          <Route path='/services/lessons' element={<LessonsPage />} />
          <Route path='/services/lessons/in-home' element={<PrivateLessonsPage />} />
          <Route path='/services/lessons/studio' element={<GroupLessonsPage />} />
          {/* Studio & Production */}
          <Route path='/services/studio' element={<StudioPage />} />
          <Route path='/services/studio/recording' element={<RecordingPage />} />
          <Route path='/services/studio/visual' element={<VisualPage />} />
          {/* Live Sound & Events */}
          <Route path='/services/live-sound' element={<LiveSoundPage />} />
          <Route path='/services/live-sound/gear-rental' element={<GearRentalPage />} />
          <Route path='/services/live-sound/audio-engineer' element={<AudioEngineerPage />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;